import React from 'react';
import { Layout } from 'antd';
import './AppFooter.css'

const { Footer } = Layout;

const FooterComponent: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Footer className='footer'>
      Powered by GhostDraft ©{currentYear}
    </Footer>
  );
};

export default FooterComponent;
